<template>
<div>

  <div class="flex gap-4">
    <button @click="toggleFilters" class="bg-gray-200 border-1 w-full p-2"><i class="fad fa-sliders-h"></i> Filters</button>
    <button @click="clearFilters" class="bg-white border w-full p-2">Reset</button>
  </div>

  <ul :class="{hidden: !filterOpen, flex: filterOpen}"
        class="my-4 mr-4 flex-wrap">
    <li id="filter-collections"
        v-if="!collectionIsLocked"
        class="my-4 w-full border-t-2 pt-1">
      <span class="flex flex-row justify-between items-center" :class="{'font-bold':selectedCollections.length}">Collections ({{selectedCollections.length}})
        <i
            class="fas"
            :class="{'fa-plus': !collectionsFilterExpanded, 'fa-minus': collectionsFilterExpanded}"
            @click="() => this.collectionsFilterExpanded = !this.collectionsFilterExpanded"
        ></i>
      </span>
      <form class="m-2 ml-1 flex-wrap" v-if="collectionsFilterExpanded" method="get" action="/search" ref="form">
        <div v-for="(collection,index) in collections"
             class="w-full">
          <input type="checkbox"
                 :id="'collection-' + index"
                 class="m-1"
                 name="collection"
                 :value="collection.search_collection.handle"
                 v-model="selectedCollections"
                 @change="submitForm" />
          <label :for="'collection-' + index">{{collection.search_label.title}}</label>
        </div>
      </form>
    </li>
    <li v-for="(filter,index) in filters"
        :id="'filter-taxonomy-' + index"
        class="my-4 w-full border-t-2 pt-1">
      <span class="flex flex-row justify-between items-center" :class="{'font-bold':initialFilter[filter.handle].length}">{{filter.title}} ({{initialFilter[filter.handle].length}})
        <i
            class="fas"
            :class="{'fa-plus': !filterIsExpanded(filter.handle), 'fa-minus': filterIsExpanded(filter.handle)}"
            @click="toggleFilterExpanded(filter.handle)"
        ></i>
      </span>
      <form class="m-2 ml-1 flex-wrap" v-if="filterIsExpanded(filter.handle)" method="get" action="/search" ref="form">
        <div v-for="(term,index) in filterTerms[filter.handle].terms"
             class="w-full">
          <input type="checkbox"
                 :id="'term-'+ filter.handle + '-' + index"
                 class="searchFilter ml-1 mr-4 mt-4 mb-4"
                 :name="filter.handle"
                 :value="term.slug"
                 v-model="initialFilter[filter.handle]"
                 @change="submitForm" />
          <label :for="'term-'+ filter.handle + '-' + index">{{term.title}}</label>
        </div>
      </form>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  name: "SideNavigation",
  props: {
    filters: {
      type: Array
    },
    filtersUpdatedFunc: {
      type: Function,
      required: true
    },
    collections: {
      type: Array,
      required: true
    },
    selectedCollections: {
      type: Array,
      required: true
    },
    initialFilter: {
      type: Object,
      default: {}
    },
    collectionIsLocked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filterOpen: true,
      filterTerms: this.createFilterEntries(this.filters, () => {return {expanded: true, terms: null};}),
      searchQuery: '',
      collectionsFilterExpanded: true
    }
  },
  methods:{
    toggleFilters(){
      this.filterOpen = !this.filterOpen;
    },
    closeFilters(){
      this.filterOpen = false
    },
    clearFilters(){
      var checkboxes = document.querySelectorAll('.searchFilter');
      checkboxes.forEach(function(checkbox) {
        checkbox.checked = false;
        // Trigger the change event manually
        var event = new Event('change');
        checkbox.dispatchEvent(event);
      });
      // this.filters = [];
      // this.submitForm();
    },
    createFilterEntries(filterArr, emptyElemGenerator){
      let obj = {};
      for(let i = 0; i < filterArr.length;i++) {
        let key = filterArr[i].handle;
        obj[key] = emptyElemGenerator();
      }
      return obj;
    },
    createSelectedFilter() {
      let filters = this.createFilterEntries(this.filters, () => []);
      for (let key in this.initialFilter) {
        filters[key] = this.initialFilter[key];
      }
      return filters;
    },
    filterIsExpanded(filterHandle){
      return this.filterTerms[filterHandle].expanded;
    },
    toggleFilterExpanded(filterHandle){
      this.filterTerms[filterHandle].expanded = !this.filterIsExpanded(filterHandle);
    },
    getQuery() {
      const params = new URLSearchParams(window.location.search);
      let query = params.get('q');
      console.log(query);
      return query;
    },
    submitForm() {
      this.$nextTick(() => {
        this.filtersUpdatedFunc(this.initialFilter, this.selectedCollections);
      });
    }
  },
  created() {
    for(let key in this.filterTerms) {
      fetch(`/api/taxonomies/${key}/terms?sort=title`)
          .then(response=>response.json())
          .then(data => {
            console.log('data received');
            this.filterTerms[key].terms = data.data;
          });
    }
  }
}
</script>

<style scoped>

</style>